export enum EEmployeeRole {
	SUPER_ADMIN = 'super_admin',
	ADMIN = 'admin',
	MES_SUPER_ADMIN = 'mes_super_admin',
	MES_ADMIN = 'mes_admin',
	PRODUCTION_MANAGER = 'mes_production_manager',
	TECHNOLOGIST = 'mes_technologist',
	PRODUCTION_COST_SPECIALIST = 'mes_production_cost_specialist',
	WAREHOUSE_OPERATOR = 'mes_warehouse_operator',
	INTERNAL_LOGISTICS = 'mes_internal_logistics',
	CONTRACT_PURCHASING_SPECIALIST = 'mes_contract_purchasing_specialist',
	DELIVERY_LOGISTICS = 'mes_delivery_logistics',
	TABLET_USER = 'mes_tablet_user',
	MES_INTEGRATION = 'mes_integration',
	CRM_INTEGRATION = 'mes_crm_integration',
	SCM_INTEGRATION = 'mes_scm_integration',
}

export const employeeRoles: ISelectOption[] = [
	{ value: EEmployeeRole.SUPER_ADMIN, label: convertRoleName(EEmployeeRole.SUPER_ADMIN) },
	{ value: EEmployeeRole.ADMIN, label: convertRoleName(EEmployeeRole.ADMIN) },
	{ value: EEmployeeRole.MES_SUPER_ADMIN, label: convertRoleName(EEmployeeRole.MES_SUPER_ADMIN) },
	{ value: EEmployeeRole.MES_ADMIN, label: convertRoleName(EEmployeeRole.MES_ADMIN) },
	{ value: EEmployeeRole.PRODUCTION_MANAGER, label: convertRoleName(EEmployeeRole.PRODUCTION_MANAGER) },
	{ value: EEmployeeRole.TECHNOLOGIST, label: convertRoleName(EEmployeeRole.TECHNOLOGIST) },
	{
		value: EEmployeeRole.PRODUCTION_COST_SPECIALIST,
		label: convertRoleName(EEmployeeRole.PRODUCTION_COST_SPECIALIST),
	},
	{ value: EEmployeeRole.WAREHOUSE_OPERATOR, label: convertRoleName(EEmployeeRole.WAREHOUSE_OPERATOR) },
	{ value: EEmployeeRole.INTERNAL_LOGISTICS, label: convertRoleName(EEmployeeRole.INTERNAL_LOGISTICS) },
	{
		value: EEmployeeRole.CONTRACT_PURCHASING_SPECIALIST,
		label: convertRoleName(EEmployeeRole.CONTRACT_PURCHASING_SPECIALIST),
	},
	{ value: EEmployeeRole.DELIVERY_LOGISTICS, label: convertRoleName(EEmployeeRole.DELIVERY_LOGISTICS) },
	{ value: EEmployeeRole.TABLET_USER, label: convertRoleName(EEmployeeRole.TABLET_USER) },
	{ value: EEmployeeRole.MES_INTEGRATION, label: convertRoleName(EEmployeeRole.MES_INTEGRATION) },
	{ value: EEmployeeRole.CRM_INTEGRATION, label: convertRoleName(EEmployeeRole.CRM_INTEGRATION) },
	{ value: EEmployeeRole.SCM_INTEGRATION, label: convertRoleName(EEmployeeRole.SCM_INTEGRATION) },
]

export const findRoleByValue = (value: EEmployeeRole) => employeeRoles.find(role => role.value === value)
